import React from "react";

import { useTranslation } from "react-i18next";

import { useCurrentClient } from "../../context/Client";

import PrintForm from "./PrintForm";
import History from "./History";

const AccessLabelsFeature: React.FC = () => {
  const { t } = useTranslation(["accessLabels", "common"]);

  const currentClient = useCurrentClient();

  const synguardEnabled =
    currentClient?.preferences?.synguard?.enabled ?? false;

  if (!synguardEnabled) {
    return (
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb my-3">
            <li className="breadcrumb-item active" aria-current="page">
              {t("accessLabels:title")}
            </li>
          </ol>
        </nav>
        <div className="text-muted ml-3">
          <p>{t("accessLabels:synguardRequired")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb my-3">
          <li className="breadcrumb-item active" aria-current="page">
            {t("accessLabels:title")}
          </li>
        </ol>
      </nav>
      <p className="text-primary mb-3">{t("accessLabels:subtitle")}</p>

      <PrintForm />
      <History />
    </div>
  );
};

export default React.memo(AccessLabelsFeature);
